import router from "@/router";
import { useStore } from "vuex";

const store = useStore();

// 定义方法接口
interface GlobalMethods {
  //方法的类型定义
  handleHelpClick: () => void
}

// 声明 Vue 的类型扩展
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties extends GlobalMethods { }
}

export const globalMixin = {
  methods: {
    //联系客服
    handleHelpClick() {
      router.push('/Chat?conversationID=CSHB100000&userName=客服&conversationType=C2C')
    }
  }
} 